import fmss from "assets/certificates/Fmss.png";
import patikaFrontend from "assets/certificates/Frontend Patika.jpeg";
import juniorNtt from "assets/certificates/Junior Gelişim Programı.jpg";
import projectManagement from "assets/certificates/Project Management.jpg";
import turkcellReact from "assets/certificates/Turkcell.png";
import innovation from "assets/certificates/İnnovation.jpg";
import webProgramming301 from "assets/certificates/web programlama 301.png";
import consultantBasics from "assets/certificates/Consultant Basics.jpg";
import reactContext from "assets/certificates/React Sertifika.jpg";

export const cercificatesData = [
  {
    name: "Fmss Front-End Practicum",
    image: fmss,
  },
  {
    name: "EDUCATION.certificates.patikaFrontend",
    image: patikaFrontend,
  },
  {
    name: "EDUCATION.certificates.juniorNtt",
    image: juniorNtt,
  },
  {
    name: "EDUCATION.certificates.turkcellReact",
    image: turkcellReact,
  },
  {
    name: "EDUCATION.certificates.projectManagement",
    image: projectManagement,
  },
  {
    name: "EDUCATION.certificates.innovation",
    image: innovation,
  },
  {
    name: "EDUCATION.items.webProgramming301",
    image: webProgramming301,
  },
  {
    name: "EDUCATION.certificates.consultantBasics",
    image: consultantBasics,
  },
  {
    name: "EDUCATION.items.reactContextAPI",
    image: reactContext,
  },
];
